import React, { useState } from 'react';
import {
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  LargeHeader,
  Visible,
  useApiWithErrors,
  ApiError,
  GoneError,
  LayoutItem,
  Layout,
  Button,
} from '@axiom/ui';
import { useParams } from 'react-router';

import { PublicEngagementToLoginModal } from '../PublicEngagementToLoginModal/PublicEngagementToLoginModal';
import { EngagementsShareContextMenu } from '../EngagementsShareContextMenu/EngagementsShareContextMenu';
import { MyEngagementsProcessSteps } from '../MyEngagementsProcessSteps/MyEngagementsProcessSteps';
import { SubmissionApi } from '../../api/submission-api';

export const PublicEngagementHeader = () => {
  const [displayLoginModal, setDisplayLoginModal] = useState(false);
  const { submissionId } = useParams();

  if (!submissionId) {
    throw new Error('submissionId was not provided');
  }

  let invalidSubmissionRequest = false;

  const [response] = useApiWithErrors(
    SubmissionApi.readSubmissionDetails(submissionId)
  );

  if (response instanceof ApiError) {
    if (response instanceof GoneError) {
      invalidSubmissionRequest = true;
    } else {
      throw response;
    }
  }
  const { data: submission } = response;
  return invalidSubmissionRequest || !submission ? null : (
    <>
      <Grid stackable name="CLIENT_ACTIONS_BANNER">
        <GridRow>
          <GridColumn largeScreenWidth={9} tabletWidth={10} mobileWidth={12}>
            <LargeHeader name="CLIENT_NAME">{submission.jobName}</LargeHeader>
            <Visible only="mobile">
              <Gutter bottom="16px" />
            </Visible>
          </GridColumn>
          <GridColumn
            largeScreenWidth={3}
            tabletWidth={2}
            mobileWidth={12}
            verticalAlign="bottom"
            textAlign="right"
          >
            <Layout
              direction="horizontal"
              position="right"
              stackableOn="mobile"
            >
              <LayoutItem>
                <EngagementsShareContextMenu
                  currentSubmission={submission}
                  onClickInviteToAccount={() => {
                    setDisplayLoginModal(true);
                  }}
                />
                <Gutter bottom="8px" only="mobile" />
              </LayoutItem>
              {submission.selfService ? (
                <>
                  <Gutter right="24px" only="tablet largeScreen" />
                  <LayoutItem>
                    <Button
                      fluid
                      name="need-help-button"
                      pattern="primary"
                      variation="outline"
                      onClick={() => {
                        setDisplayLoginModal(true);
                      }}
                    >
                      Need Help?
                    </Button>
                  </LayoutItem>
                </>
              ) : null}
            </Layout>
          </GridColumn>
        </GridRow>
      </Grid>
      <Gutter vertical="16px">
        <MyEngagementsProcessSteps submission={submission} />
      </Gutter>
      {!!displayLoginModal && (
        <PublicEngagementToLoginModal
          onClose={() => {
            setDisplayLoginModal(false);
          }}
        />
      )}
    </>
  );
};
